
import { Vue } from 'vue-property-decorator';
export default class LoadingTestPanel extends Vue {}
